import Vue from 'vue';
import App from './app.vue';
import VueMask from 'v-mask';
import {
    extend,
    setInteractionMode
} from 'vee-validate';
import Notifications from 'vue-notification';
import {
    regex,
    required,
    min_value
} from 'vee-validate/dist/rules';

import './utils/services/global-config-service';
import './utils/services/postmsg-expose-service';
import './utils/services/postmsg-publish-service';
import { credit_card } from './utils/constants/validation-constants';

import './assets/scss/layout.scss'

// Validation Rules
extend('required', {
    ...required,
    message: 'required_field_error'
});

extend('regex', {
    ...regex,
    message: 'incorrect_field_error'
});

extend('min_value', {
    ...min_value,
    message: 'min_value_field_error'
});

extend('credit_card', {
  ...credit_card,
  message: 'incorrect_card'
});

setInteractionMode('validateOnBlur', () => {
    return { on: ['blur'] };
});

Vue.use(VueMask);
Vue.use(Notifications);
Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
}).$mount('#app');
